/** Activity log entries in words. Its own file so Admin can use it without loading the staff screens. */
export const AUDIT_NAMES: Record<string, string> = {
  "account.create": "Account created",
  "account.go-live": "Went live",
  "account.turn-off": "Turned off",
  "account.remove": "Farm removed",
  "account.merge": "Account merged in",
  "site.rename": "Farm renamed",
  "ticket.new": "Ticket raised",
  "ticket.status": "Ticket closed or reopened",
  "account.turn-on": "Turned back on",
  "account.plan": "Plan changed",
  "billing.free": "Payment waived",
  "billing.standard": "Charged normally again",
  "site.add": "Site added",
  "user.add": "User added",
  "user.invite": "Invite sent",
  "user.reinvite": "Invite sent again",
  "device.add": "Device added",
  "invite.accepted": "Invite accepted",
  "terms.accepted": "Terms accepted",
  "sign-in": "Signed in",
  command: "Command",
  "port.setup": "Port set up",
  "safety-rule": "Safety rule",
  "bench-test": "Bench test",
  "safety-timer": "Safety timer",
  "user.change": "Access changed",
  "user.disable": "Access removed",
  "user.enable": "Access given back",
  settings: "Farm settings changed",
  "alert.ack": "Alert acknowledged",
  "gateway.name": "Gateway named",
  "email.test": "Test email sent",
  "user.edit": "Draft user changed",
  "user.remove-draft": "Draft user removed",
  "account.control-on": "Cut over: Think-Control runs the devices",
  "account.control-off": "Handed back to FMS-Control",
  "device.note": "Service note added",
  "device.note-delete": "Service note deleted",
};
